import type { ReactNode } from 'react';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import '../native-controls.css';

// Both portals render this once at the root. Change tokens here — never
// per-app — so the tenant and admin portals can never visually drift apart.
const THEME_PROPS = {
  appearance: 'light',
  accentColor: 'indigo',
  grayColor: 'slate',
  radius: 'small',
  panelBackground: 'solid',
} as const;

export function PortalTheme({ children }: { children: ReactNode }) {
  return <Theme {...THEME_PROPS}>{children}</Theme>;
}
